import Image from "next/image";


type IconProps = {
	src: string;
	size?: number;
	alt?: string;
	className?: string;
};

export default function Icon({
	src,
	size = 24,
	alt = "",
	className = "",
}: IconProps) {
	return (
		<Image src={src} alt={alt} width={size} height={size} className={className} />
	);
}
